import TabsNavContainer from "components/shared/TabsNavContainer";
import TabLink from "hardcover-ui/components/TabLink";
import { UserSerializersUserByline } from "types/serializers";

type Props = {
  user: UserSerializersUserByline
  className?: string;
};

const SIZE = "md";

export default function UserNav({ user, className }: Props) {
  return (
    <TabsNavContainer className={className}>
      <TabLink
        size={SIZE}
        href={`/@${user.username}`}
        className="flex items-center space-x-2 flex-none"
      >
        <span>@{user.username}</span>
      </TabLink>
      <TabLink href={`/@${user.username}/books`} size={SIZE} greedy>
        <>Books</>
      </TabLink>
      <TabLink href={`/@${user.username}/stats`} size={SIZE}>
        <>Stats</>
      </TabLink>
      <TabLink href={`/@${user.username}/reviews`} size={SIZE} greedy>
        <>Reviews</>
      </TabLink>
      <TabLink href={`/@${user.username}/lists`} size={SIZE} greedy>
        <>Lists</>
      </TabLink>
      <TabLink
        href={`/@${user.username}/prompts/answered`}
        size={SIZE}
        greedy={`/@${user.username}/prompts`}
      >
        <>Prompts</>
      </TabLink>
      <TabLink href={`/@${user.username}/goals`} size={SIZE} greedy>
        <>Goals</>
      </TabLink>
      <TabLink
        href={`/@${user.username}/network/following`}
        size={SIZE}
        greedy={`/@${user.username}/network`}
      >
        <>Network</>
      </TabLink>
      <TabLink href={`/@${user.username}/activity`} size={SIZE} greedy>
        <>Activity</>
      </TabLink>

      {/* <ActiveLink
        href="#badges"
        active={activeLinkClass}
        inactive={inactiveLinkClass}
      >
        <>Badges</>
      </ActiveLink> */}
    </TabsNavContainer>
  );
}
